import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { RestoreService } from "./restore.service";

@Component({
    selector: 'app-restore',
    templateUrl: './restore.component.html'
})
export class RestoreComponent {
    public showLoader: boolean = false;

    constructor(private service: RestoreService) { }

    public register(credentials) {
        if (!this.showLoader) {
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/public/restore/restore.component.ts